import {Injectable, signal} from '@angular/core';
import {PaymentDTO} from '../../../domain/model/payment.model';
import {SynchronizableStore} from "@platform/storage/application/storage.synchronizer";

export interface PaymentChargeState {
  readonly payments: PaymentDTO[];
}

@Injectable({providedIn: 'root'})
export class PaymentChargeStore implements SynchronizableStore<PaymentChargeState> {
  private readonly _state = signal<PaymentChargeState>({payments: []});
  readonly state = this._state.asReadonly();

  set(payments: PaymentDTO[]): void {
    this._state.set({payments: [...payments]});
  }

  clear(): void {
    this._state.set({payments: []});
  }

  patch(state: PaymentChargeState): void {
    this._state.set({payments: [...state.payments]});
  }
}
